export enum Operator {
  In = 0,
  NotIn = 1
}
